import React from 'react';
import './AutoAlgoTrial.css';

const TRIAL_CHECKOUT_URL = 'https://www.jtncgroup.com/offers/kizPDmwt';
const TRADIER_SIGNUP_URL = 'https://trade.tradier.com/wl2/';

const AutoAlgoTrial = () => (
  <section className="qtrial-wrap" id="auto-algo-trial">
    <div className="qtrial-head">
      <h2 className="qtrial-headline">Try our flagship $12K subscription for only $197</h2>
      <p className="qtrial-sub">Your $197 is <b>RISK FREE</b> with our money-back guarantee</p>
    </div>
    <article className="qtrial">
      <span className="qtrial-pop">New · 30-day trial</span>

      <div>
        <div className="qtrial-kicker">30-Day Trial</div>
        <h3>Quantum Flo Auto Algo</h3>
        <div className="qtrial-price">
          <span className="qtrial-amt">$197</span>
          <span className="qtrial-per">for 30 days</span>
        </div>
        <div className="qtrial-note">One-time offer · limit one per client</div>
      </div>

      <ul className="qtrial-feats">
        <li><b>1 to 4 automated trades per day</b> in SPY and QQQ</li>
        <li>Potential to earn <b>$2,000 to $4,000 per month</b>*</li>
        <li>Up to <b>$500 risk per trade</b></li>
        <li>Requires a Tradier account funded with <b>$5,000</b></li>
        <li>After 30 days, <b>apply your $197 toward an annual subscription</b>, or keep any profits and walk away</li>
      </ul>

      <div className="qtrial-cta">
        <a className="qtrial-btn" href={TRIAL_CHECKOUT_URL}>Start my 30-day trial</a>
        <div className="qtrial-link">
          New to Tradier?{' '}
          <a href={TRADIER_SIGNUP_URL} target="_blank" rel="noopener noreferrer">Open your account &rarr;</a>
        </div>
      </div>

      <div className="qtrial-guar">
        <span className="qtrial-guar-ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l7 3v5c0 4.6-2.9 8.3-7 10-4.1-1.7-7-5.4-7-10V6l7-3z" />
            <path d="M8.8 12.2l2.3 2.3 4.2-4.6" />
          </svg>
        </span>
        <div>
          <div className="qtrial-guar-head">Money-back guarantee</div>
          <div className="qtrial-guar-text">Don&apos;t earn at least $500 in your 30 days? We refund your $197 in full.</div>
          <div className="qtrial-guar-cond">Requires the strategy turned on every trading day, at $500 risk per trade in both SPY and QQQ.</div>
        </div>
      </div>

      <p className="qtrial-fine">*Earnings are not guaranteed. Trading involves risk, and you can lose money. Past performance is not indicative of future results.</p>
    </article>
  </section>
);

export default AutoAlgoTrial;
